<!--  -->
<template>
  <div>
    <div class="examples_rightbox">
      <div class="input_box">
        <div style="width: 45px;">标题:</div>
        <div><el-input v-model="form.title" style="width: 450px !important;" maxlength="40" placeholder="请输入标题" @blur="titlblure" /></div>
        <div style="display:flex;align-items: center;">
          <div style="margin-left:10px;">
            随机标题：
          </div>
          <el-radio-group v-model="rand_title" class="serwr" size="mini" @change="changewrrr">
            <el-radio-button type="success" :label="1">随机</el-radio-button>
            <el-radio-button type="success" :label="0">不随机</el-radio-button>
          </el-radio-group>

        </div>
      </div>
      <div v-if="title_options.length!==0 && rand_title == 1" style="margin-top: 10px;margin-right: 30px;">
        <div style="font-size: 16px;margin-bottom: 5px;">随机标题:</div>
        <div style="margin-left: 40px;margin-top:10px">
          <div v-for="itemq,indexq in title_options" :key="indexq">
            <el-input v-model.trim="title_options[indexq]" maxlength="40" style="width: 500px;margin-bottom: 10px;" placeholder="请输入内容" />
            <el-button type="danger" size="mini" style="margin-left:10px" @click="deater(1,indexq)">删除</el-button>
          </div>
        </div>
      </div>
      <div class="input_box">
        <div>链接：</div>
        <div><el-input v-model.trim="form.url" style="width: 450px !important;" placeholder="请输入链接" @blur="handleInput" /></div>
        <div v-if="userIfon.external == false" style="margin-left:10px;">
          保存到系统：
        </div>
        <el-radio-group v-if="userIfon.external == false" v-model="replace_link" class="serwr" size="mini">
          <el-radio-button type="success" :label="1">否</el-radio-button>
          <el-radio-button type="success" :label="2">是</el-radio-button>
        </el-radio-group>
      </div>
      <div class="input_box">
        <div>描述：</div>
        <div>
          <el-input v-model="form.description" maxlength="20" style="width:450px" type="textarea" placeholder="请输入描述" @blur="desrblure" />
        </div>
        <div style="display:flex;align-items: center;">
          <div style="margin-left:10px;">
            随机描述：
          </div>
          <el-radio-group v-model="rand_desc" class="serwr" size="mini" @change="changew">
            <el-radio-button type="success" :label="1">随机</el-radio-button>
            <el-radio-button type="success" :label="0">不随机</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div v-if="desc_options.length!==0 && rand_desc == 1" style="margin-top: 10px;">
        <div style="font-size: 16px;margin-bottom: 5px;margin-right: 2px;">随机描述:</div>
        <div style="margin-left: 40px;margin-top:10px;height: 270px;overflow: auto;">
          <div v-for="itemq,indexq in desc_options" :key="indexq">
            <el-input
              v-model.trim="desc_options[indexq]"
              maxlength="20"
              type="textarea"
              :rows="5"
              style="width: 500px;margin-bottom: 10px;"
              placeholder="请输入内容"
            />
            <el-button type="danger" size="mini" style="margin-left:10px" @click="deater(2,indexq)">删除</el-button>
          </div>
        </div>
      </div>
      <div class="cover_box">
        <div>封面：</div>
        <el-button type="primary" size="mini" @click="materiallibrary">{{ multipleCovers && covers.length ? '添加封面' : '选择封面' }}</el-button>
        <span v-if="multipleCovers" class="cover_hint">可添加多张封面，已选 {{ covers.length }} 张</span>
      </div>
      <div v-if="covers.length" class="cover_list">
        <div v-for="(cover, index) in covers" :key="index" class="cover_item">
          <el-image :src="cover.picurl" fit="cover" class="cover_image" title="点击更换封面" @click.native="materiallibrary(index)" />
          <el-button v-if="multipleCovers" type="text" class="cover_remove" @click="removeCover(index)">删除</el-button>
        </div>
      </div>
    </div>
    <!-- <div style="display: flex;margin-top: 10px;">
      <div v-if="title_options.length!==0" class="cover_box" style="margin-top: 10px;margin-right: 30px;">
        <div style="font-size: 16px;margin-bottom: 5px;margin-right: 2px;">随机标题:</div>
        <div>
          <div v-for="itemq,indexq in title_options" :key="indexq">
            <el-input v-model="title_options[indexq]" style="width: 300px;margin-bottom: 10px;" placeholder="请输入内容" />
          </div>
        </div>
      </div>
      <div v-if="desc_options.length!==0" class="cover_box" style="margin-top: 10px;">
        <div style="font-size: 16px;margin-bottom: 5px;margin-right: 2px;">随机描述:</div>
        <div>
          <div v-for="itemq,indexq in desc_options" :key="indexq">
            <el-input v-model="desc_options[indexq]" style="width: 300px;margin-bottom: 10px;" placeholder="请输入内容" />
          </div>
        </div>
      </div>
    </div> -->

    <div style="margin-left:65px;margin-top:10px"><el-button type="primary" @click="sumbit">确定</el-button></div>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      append-to-body
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
  </div>
</template>

<script>
// import chooseimg from '../../menumanagement/components/chooseimg.vue'
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
import { getRandomTextOptions } from '@/utils/randomTextOptions'
import { getLinkCovers, getLinkCoverFields, isCompleteLinkCover } from '@/utils/linkCovers'
import { getInfo } from '@/api/user'
export default {
  components: { chooseimg },
  props: {
    multipleCovers: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        title: '',
        url: '',
        description: '',
        testsrc: '',
        source_material_id: ''
      },
      dialogVisibletwo: false,
      replaceCoverIndex: null,
      covers: [],
      rand_title: 1,
      title_options: [],

      rand_desc: 1,
      desc_options: [],
      replace_link: 1,
      userIfon: {}
    }
  },
  computed: {
    coverPreviewUrls() {
      return this.covers.map(cover => cover.picurl).filter(Boolean)
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    info() {
      getInfo().then(data => {
        this.userIfon = data.data
      })
    },
    materiallibrary(index) {
      this.replaceCoverIndex = typeof index === 'number' ? index : null
      this.dialogVisibletwo = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      const replaceIndex = this.replaceCoverIndex
      this.replaceCoverIndex = null
      this.dialogVisibletwo = false
      const cover = { picurl: img, source_material_id: key }
      if (!isCompleteLinkCover(cover)) {
        this.$message.error('图片信息不完整，请重新选择封面')
        return
      }
      if (typeof replaceIndex === 'number') {
        this.$set(this.covers, replaceIndex, cover)
      } else if (this.multipleCovers) {
        if (!this.covers.some(item => String(item.source_material_id) === String(key))) {
          this.covers.push(cover)
        }
      } else {
        this.covers = [cover]
      }
      this.syncCover()
    },
    removeCover(index) {
      this.covers.splice(index, 1)
      this.syncCover()
    },
    syncCover() {
      const fields = getLinkCoverFields(this.covers)
      this.form.testsrc = fields.picurl
      this.form.source_material_id = fields.source_material_id
    },
    send(item = {}) {
      this.info()
      this.form = {
        title: item.title || '',
        url: item.url || '',
        description: item.desc || '',
        testsrc: '',
        source_material_id: ''
      }
      this.covers = getLinkCovers(item)
      this.syncCover()
      this.rand_title = item.rand_title == null ? 1 : item.rand_title
      this.title_options = Array.isArray(item.title_options) ? item.title_options.slice() : []
      this.rand_desc = item.rand_desc == null ? 1 : item.rand_desc
      this.desc_options = Array.isArray(item.desc_options) ? item.desc_options.slice() : []
      this.replace_link = item.replace_link == null ? 1 : item.replace_link
    },
    sumbit() {
      if (!(this.form.title || '').trim()) {
        this.$message.error('请填写标题')
        return
      }
      if (this.form.url === '') {
        this.$message.error('请填写链接')
        return
      }
      const reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
      if (!reg.test(this.form.url)) {
        this.$message.error('请填写正确链接')
        return
      }
      if (!(this.form.description || '').trim()) {
        this.$message.error('请填写描述')
        return
      }
      if (!this.covers.length) {
        this.$message.error('请选择封面')
        return
      }
      if (!this.covers.every(isCompleteLinkCover)) {
        this.$message.error('封面图片与素材ID不匹配，请重新选择封面')
        return
      }
      if (this.rand_title === 1) {
        if (this.title_options.length === 0) {
          this.$message.error(`请完善要编辑替换的标题`)
          return
        }
        for (let i = 0; i < this.title_options.length; i++) {
          if (this.title_options[i] === '') {
            this.$message.error(`请完善要编辑替换的标题`)
            return
          }
        }
      }
      if (this.rand_desc === 1) {
        if (this.desc_options.length === 0) {
          this.$message.error(`请完善要编辑替换的描述`)
          return
        }
        for (let i = 0; i < this.desc_options.length; i++) {
          if (this.desc_options[i] === '') {
            this.$message.error(`请完善要编辑替换的描述`)
            return
          }
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.userIfon.external == false && this.replace_link == 2) {
        if (!this.form.url.endsWith('.html')) {
          this.$message.error('链接必须以 .html 结尾')
          return
        }
      }
      // rand_title: 1,
      // title_options: [],

      // rand_desc: 1,
      // desc_options: []

      const form = { ...this.form, ...getLinkCoverFields(this.covers) }
      this.$emit('callback', form, this.rand_title, this.title_options, this.rand_desc, this.desc_options, this.replace_link)
    },
    titlblure() {
      return this.seet()
    },
    desrblure() {
      return this.seetr()
    },
    seet() {
      return this.generateRandomOptions('title', 'rand_title', 'title_options', '请先填写标题')
    },
    seetr() {
      return this.generateRandomOptions('description', 'rand_desc', 'desc_options', '请先填写描述')
    },
    changewrrr() {
      return this.seet()
    },
    changew() {
      return this.seetr()
    },
    async generateRandomOptions(field, randomField, optionsField, message) {
      const text = this.form[field]
      if (this[randomField] !== 1) {
        this[optionsField] = []
        return
      }
      if (!(text || '').trim()) {
        this[optionsField] = []
        this.$message.error(message)
        return
      }
      const options = await getRandomTextOptions(text)
      if (this[randomField] === 1 && this.form[field] === text) {
        this[optionsField] = options
      }
    },
    deater(type, index) {
      if (type === 1) {
        this.title_options.splice(index, 1)
      } else {
        this.desc_options.splice(index, 1)
      }
    },
    handleInput(event) {
      this.form.url = event.target.value.replace(/\s/g, '')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.examples_rightbox{
  margin-left: 30px;
}
.input_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.cover_box{
  display: flex;
  align-items: center;
}
.cover_hint {
  margin-left: 10px;
  color: #74839a;
  font-size: 12px;
}
.cover_list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 16px 0 0 40px;
}
.cover_item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cover_image {
  width: 80px;
  height: 80px;
  border: 1px solid #e6ecf5;
  border-radius: 4px;
  cursor: pointer;
}
.cover_remove {
  color: #f56c6c;
  padding: 8px 0;
}
.serwr /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner{
  background-color:#67C23A;
  border-color: #67C23A;
}
</style>
